import { render, staticRenderFns } from "./CardReceita.vue?vue&type=template&id=cc3928ba&scoped=true&"
import script from "./CardReceita.vue?vue&type=script&lang=js&"
export * from "./CardReceita.vue?vue&type=script&lang=js&"
import style0 from "./CardReceita.vue?vue&type=style&index=0&id=cc3928ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3928ba",
  null
  
)

export default component.exports